import * as actions from './actions';
import * as getters from './getters';
import AppointmentsState from './state';

export { actions, getters };
export default AppointmentsState;
